import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { availabilityShape } from '@bibliocommons/bc-prop-types';

import ResourcesList from 'app/components/bibs/shared/ResourcesList';
import { MATERIAL_TYPE_DIGITAL } from 'app/constants/BibConstants';
import holdingShape from 'app/shapes/holdingShape';

import './ElectronicResourceInfo.scss';

export default function ElectronicResourceInfo({ realtimeAvailability, holdings, handleClick }) {
  const bibType = realtimeAvailability.get('bibType');

  if (bibType !== MATERIAL_TYPE_DIGITAL && holdings.size > 0) {
    return (
      <div className="cp-electronic-resource">
        <div className="electronic-resource-label">
          <FormattedMessage id="bib_online_resource" />
        </div>
        <ResourcesList resources={holdings} handleClick={handleClick} />
      </div>
    );
  }

  return null;
}

ElectronicResourceInfo.propTypes = {
  realtimeAvailability: availabilityShape.isRequired,
  holdings: ImmutablePropTypes.listOf(holdingShape).isRequired,
  handleClick: PropTypes.func
};
